import axios from 'axios';

export default async function getAllCompanyGuests({
  accessToken,
  companyId,
  page = 0,
  pageSize = 30,
  query = '',
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const { data } = await axios.get(
    `${process.env.REACT_APP_GUESTS_API_URL}/company/${companyId}?page=${page}&pageSize=${pageSize}&query=${query}`,
    requestOptions,
  );

  return data;
}
